/**
 * Define the menu elements of the variable prompt menu, representing different prompt types
 */

define(["backbone", "messaging/messenger", "modules/shared/adminMenu/adminMenuModel"], function (
  Backbone,
  Messenger,
  AdminMenuModel,
) {
  Messenger.reqres.setHandler("prompt:menu:items", function (constraints) {
    var menuItems = new AdminMenuModel.menuItems([
      {
        name: "missingVariable",
        label: "topics.variablePrompts.missingVariablePrompt",
        default: true,
      }, //selected by default
      //disable the invalid variable menu item if the variable does not have a constraint
      {
        name: "invalidVariable",
        label: "topics.variablePrompts.invalidVariablePrompt",
        disabled: constraints.get("constraintType") === 0,
      },
    ]);
    return menuItems;
  });

  Messenger.reqres.setHandler("prompt:menu:style", function () {
    return new AdminMenuModel.menuType({ type: "pills", stacked: true });
  });
});
